
export interface FilterRule {
  field: "summary" | "description";
  kind: "contains" | "regex";
  value: string;
}

export enum GoogleEventResponseStatus {
  needs_action = "needsAction",
  declined = "declined",
  tentative = "tentative",
  accepted = "accepted"
}

export interface StatusTransform {
  needs_action: GoogleEventResponseStatus;
  declined: GoogleEventResponseStatus;
  tentative: GoogleEventResponseStatus;
  accepted: GoogleEventResponseStatus;
  deleted_declined: boolean;
}

export enum EventVisibility {
  DEFAULT = "default",
  PRIVATE = "private",
  CONFIDENTIAL = "confidential",
  PUBLIC = "public",
  KEEP_ORIGINAL = "keep_original"
}

export enum Transparency {
  keep_original = "keep_original",
  set_to_transparent = "set_to_transparent",
  set_to_opaque = "set_to_opaque",
  ignore_transparent = "ignore_transparent",
  ignore_opaque = "ignore_opaque"
}

export interface SyncRule {
  source: string,
  destination: string,
  uuid: string,
  summary: string,
  description: string | null,
  filter_rule: FilterRule | null,
  status_transform: StatusTransform | null,
  visibility: EventVisibility | null,
  color: string | null,
  keep_location: boolean | null,
  transparency: Transparency | null
}

